import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'antd';
import { addHelp } from '@resources/Help/actions';
import { doAction } from '@resources/Action/actions';
import { getCookie } from '@common/utils/cookie';

const Help = ({
  socket,
  helps,
  puzzle,
  solution,
  addHelp,
  doAction,
  channel,
  location,
}) => {
  const u = getCookie('GHPuser') ? JSON.parse(getCookie('GHPuser')) : {};
  if (!solution) {
    return null;
  }
  if (helps.filter((help) => help === puzzle).length > 0) {
    return solution;
  }

  if (helps.length >= 3) {
    return 'Your team have used up all of your 3 help chances. You will not be able to request for help on this puzzle.';
  }

  return (
    <Button
      onClick={() => {
        doAction({
          game: 'grand-hotel-pro',
          channel: socket.channel,
          event: 'log',
          message: {
            game: 'grand-hotel-pro',
            id: socket.id,
            name: u.name,
            location,
            channel,
            puzzle,
            message: `has clicked the help button for the ${location} puzzle`,
          },
        });

        Modal.confirm({
          title: 'Ask for help',
          content: (
            <div>
              You have {3 - helps.length} chances to ask for help. Do you want
              to ask help for this puzzle? <br />
            </div>
          ),
          onOk: () => {
            addHelp(puzzle);
            doAction({
              game: 'grand-hotel-pro',
              channel: socket.channel,
              event: 'notification',
              message: {
                game: 'grand-hotel-pro',
                type: 'info',
                title: `${location} Puzzle Help Requested`,
                description: `Your team member ${
                  u.name ? u.name : ''
                } has requested for help to solve ${location} Puzzle. The hint for the Puzzle has been revealed. Your team have ${2 -
                  helps.length} help requests left.`,
              },
            });
            doAction({
              game: 'grand-hotel-pro',
              channel: socket.channel,
              event: 'help',
              message: {
                game: 'grand-hotel-pro',
                puzzle,
                channel,
              },
            });
            doAction({
              game: 'grand-hotel-pro',
              channel: socket.channel,
              event: 'log',
              type: 'help',
              message: {
                game: 'grand-hotel-pro',
                id: socket.id,
                name: u.name,
                location,
                channel,
                puzzle,
                message: `has requested help for the ${location} puzzle`,
              },
            });
          },
        });
      }}
    >
      Ask for help
    </Button>
  );
};

const mapStateToProps = (state) => {
  return {
    helps: state.helps,
    socket: state.socket,
  };
};

export default connect(mapStateToProps, { addHelp, doAction })(Help);
